module.exports = __webpack_public_path__ + "static/media/seine.0e689081.jpeg";